<template>
    <div>
        <div v-if="message.direction === 'IN'" class="d-flex flex-row justify-content-start">
            <div>
                <p class="small p-2 me-3 mb-1 text-white rounded rounded-lg bg-primary">
                    <span v-if="attachments" v-for="a in attachments" class="d-block">
                        <a class="text-white" :href="a.url" target="_blank">
                            <img v-if="a.type === 'photo'" :src="a.url" alt="" style="max-width: 200px; max-height: 200px;">
                            <span v-else><i class="fas fa-download"></i> {{a.text ? a.text : a.type}}</span>
                        </a>
                    </span>
                    <span v-if="message.text && message.text.length" class="mr-3">{{message.text}}</span>
                    <span v-if="message.created_at" class="small text-white-50">{{created_at}}</span>
                </p>
            </div>
        </div>
        <div v-if="message.direction === 'OUT'" class="d-flex flex-row justify-content-end">
            <div>
                <p class="small p-2 ms-3 mb-1 rounded rounded-lg" style="background-color: #f5f6f7;">
                    <span v-if="attachments" v-for="a in attachments" class="d-block">
                        <a :href="a.url" target="_blank">
                            <img v-if="a.type === 'photo'" :src="a.url" alt="" style="max-width: 200px; max-height: 200px;">
                            <span v-else><i class="fas fa-download"></i> {{a.text ? a.text : a.type}}</span>
                        </a>
                    </span>
                    <span v-if="message.text && message.text.length" class="mr-3">{{message.text}}</span>
                    <span v-if="message.created_at" class="small text-muted">{{created_at}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessagesGroup",
    props: ['message'],
    computed: {
        attachments() {
            if (this.message.attachments) {
                return JSON.parse(this.message.attachments)
            }
            return null;
        },
        created_at() {
            return moment(this.message.created_at).format('HH:mm');
        }
    },
}
</script>

<style scoped>

</style>
